import { render } from "./ImageViewerFooter.vue?vue&type=template&id=2c91810f&scoped=true&ts=true"
import script from "./ImageViewerFooter.vue?vue&type=script&lang=ts"
export * from "./ImageViewerFooter.vue?vue&type=script&lang=ts"

import "./ImageViewerFooter.vue?vue&type=style&index=0&id=2c91810f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c91810f"]])

export default __exports__